"use client";

import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";
import Link from "next/link";

import useMediaQuery from "@/hooks/useMediaQuery";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "../ui/Button/Button";
import Icon from "../ui/Icon/Icon";
import { HistoryCard } from "./types";

type Props = {
  card: HistoryCard;
  index: number;
  year?: number;
  setOpenModalCard: Function;
};
export const HistorySlideCard: React.FC<Props> = ({ card, index, year, setOpenModalCard }) => {
  const isMobile = useMediaQuery("(max-width: 1023px)");
  const locale = useLocale();
  const displayOvertitle = (card.displayOvertitle === undefined || card.displayOvertitle) && (card.overtitle || year);

  return (
    <div
      className={`relative w-[311px] md:w-[365px] max-w-[100vw] text-center text-white rounded-2xl overflow-hiddens`}
      onClick={(e) => {
        card.modal && setOpenModalCard({ card, year });
        if (!isMobile) e.currentTarget.scrollIntoView({ block: "center" });
      }}
    >
      <div
        className={`absolute inset-0 z-0 rounded-2xl ${card?.cardBackgroundColor ? "" : "bg-[#808080] backdrop-blur-xl"}`}
        style={{
          backgroundColor: card?.cardBackgroundColor || undefined,
          opacity: card?.cardBackgroundOpacity || 1,
        }}
      />

      <div className="relative z-10 flex flex-col gap-[20px] justify-between items-center p-l pb-[40px] h-full">
        <div className="w-full">
          {displayOvertitle && <p className="font-primary text-s">{card.overtitle || year}</p>}
          {!isMobile && card.icon && card.icon.link.icon && (
            <div className={`w-full flex justify-center ${displayOvertitle && "mt-s"}`}>
              <Icon className="stroke-white opacity-60" name={card.icon.link.icon} title={card.icon.label} size="56" />
            </div>
          )}
          <p
            style={{ lineHeight: "130%" }}
            className={`font-primary font-medium uppercase ${displayOvertitle && !(!isMobile && card.icon && card.icon.link.icon) ? "mt-s" : "mt-l"} mb-[20px] text-l line-clamp-3`}
            title={card.title}
          >
            {card.title}
          </p>
          <p className="font-secondary-light text-m">{truncateText(card.description)}</p>
        </div>
        {card.cta ? (
          <Link
            href={card?.cta?.link?.url || getLink(card.cta, locale)}
            className="btn btn-medium btn-primary-white inline-block !border-white hover:!border-0"
            onClick={(event) => {
              if (card?.modal) {
                event.preventDefault();
              }
            }}
          >
            {card.cta.label}
          </Link>
        ) : (
          card.modal && (
            <Button
              size={ButtonSize.MEDIUM}
              variant={ButtonVariant.PRIMARY}
              theme={ButtonTheme.WHITE}
              onClick={() => setOpenModalCard({ card, year })}
              customClass="!border-white hover:!border-0"
            >
              {card.modal.label}
            </Button>
          )
        )}
      </div>
    </div>
  );
};

function truncateText(text: string, maxLength = 330) {
  if (text?.length > maxLength) return text?.substring(0, maxLength) + "...";
  else return text;
}
